<!-- 图片弹窗 -->
<template>
  <el-dialog :visible.sync="visible" :before-close="handleClose" top="50px">
    <img :src="detail.pic" class="w-full" />
    <div class="mt-[20px] flex items-center justify-between">
      <div>
        <p class="mb-[10px] text-[14px] font-bold">{{ detail.title }}</p>
        <p class="mb-[0px] flex items-center text-[14px]">
          作者：{{ detail.author }}
          <el-divider direction="vertical" class=""></el-divider>
          {{ detail.create_time }}
        </p>
      </div>
      <div>
        <el-button size="small" @click="fileDownload(detail.pic, detail.title)">
          <Icon icon="lucide:download" class="text-[20px] text-[#646464]"></Icon>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/utils/eventbus';
import { fileDownload } from '@/utils/tool';

import { Icon } from '@iconify/vue2';

export default {
  name: 'DialogImage',
  components: { Icon },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 图片弹窗详情
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    fileDownload,
    handleClose() {
      EventBus.$emit('dialogImageVisible', false, {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
